var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityScorecard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3671 2.40625L10.2247 3.07509L8.50726 4.0709L10.2247 5.07415L11.3671 5.73555L14.227 7.4076V4.0709L11.3671 2.40625Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.35736 0.0722656L4.4975 1.73692V5.07364L6.2149 4.07039L7.35736 3.40899L10.2246 1.73692L7.35736 0.0722656Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.487808 4.0709V7.4076L1.63028 8.069L3.34768 9.07227V2.40625L0.487808 4.0709Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.49752 11.0717L0.487808 8.73828V12.075L3.34768 13.7397L4.49752 13.0708L6.21492 12.075L4.49752 11.0717Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.50722 12.0736L7.35736 12.735L4.4975 14.407L7.35736 16.0717L10.2246 14.407V11.0703L8.50722 12.0736Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.0845 8.06806L11.3671 7.07227V13.7383L14.227 12.0736V8.73693L13.0845 8.06806Z",
    fill: "#6641F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.78731 10.572L10.2246 9.73967V6.40293L7.35736 4.73828L4.4975 6.40293V9.73967L7.35736 11.4043L8.78731 10.572Z",
    fill: "#6641F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityScorecard);
export default __webpack_public_path__ + "static/media/securityScorecard.1f40506550ad4c229d996afdb40abdc9.svg";
export { ForwardRef as ReactComponent };